// libraries
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import * as priorBalanceSelectors from '@makemydeal/dr-dash-store/selectors/priorBalanceSelectors';
import type { DealHistory, StateTree } from '@makemydeal/dr-dash-types';

// consts
import * as constants from '../../constants';

// components
import DealSummaryItem from '../common/DealSummaryItem';

// hooks
import { useDealSummary } from '../../common/DealSummaryProvider';
import { createDealRootSelector } from '../../offerCompareColumn/hooks/createDealRootSelector';

// feature toggles
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

// styles
import { detailedViewValueStyles } from '../utils/styles';
import { useTrackedSelector } from '../../telemetry/useTrackedSelector';

export type PriorBalanceProps = {
    deal?: DealHistory;
    hasDelta?: boolean;
};

const selectPriorBalanceAmount = (state: StateTree): number => offerReduxSelectors.getPriorLeaseBalance(state).amount ?? 0;

const PriorBalance = ({ deal, hasDelta = false }: PriorBalanceProps) => {
    const useDealRootSelector = createDealRootSelector(deal, 'PriorBalance');

    const isPriorBalanceEnabled = useTrackedSelector(featureToggleSelectors.isPriorBalanceEnabled, {
        component: 'PriorBalance',
        field: 'priorBalanceEnabled'
    });
    const offerType = useDealRootSelector(offerReduxSelectors.getCurrentOfferType, 'currentOfferType', { emitValue: true });
    const priorBalanceAmount = useDealRootSelector(selectPriorBalanceAmount, 'priorLeaseBalanceAmount');
    const { showDetailedView } = useDealSummary();

    if (!isPriorBalanceEnabled || !priorBalanceSelectors.isPriorBalanceSupportedForOfferType(offerType)) {
        return null;
    }

    return (
        <DealSummaryItem
            label={constants.PRIOR_BALANCE}
            value={formatDollarsAndCents(priorBalanceAmount)}
            hasDelta={hasDelta}
            valueStyles={showDetailedView ? detailedViewValueStyles : {}}
        />
    );
};

export default PriorBalance;
